import { render, staticRenderFns } from "./personalClaims.vue?vue&type=template&id=82120288&scoped=true&"
import script from "./personalClaims.vue?vue&type=script&lang=js&"
export * from "./personalClaims.vue?vue&type=script&lang=js&"
import style0 from "./personalClaims.vue?vue&type=style&index=0&id=82120288&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82120288",
  null
  
)

export default component.exports